import { Injectable, signal } from '@angular/core';

export type BundlingDialogVariant = 'v3_postinfo' | 'v4_postonline';

@Injectable({
  providedIn: 'root',
})
export class BundlingDialogService {
  private _isOpen = signal(false);
  isOpen = this._isOpen.asReadonly();

  private _variant = signal<BundlingDialogVariant>('v3_postinfo');
  variant = this._variant.asReadonly();

  private _onContinue?: () => void;

  openWithCallback(onContinue: () => void, variant: BundlingDialogVariant = 'v3_postinfo') {
    this._onContinue = onContinue;
    this._variant.set(variant);
    this._isOpen.set(true);
  }

  continue() {
    this._isOpen.set(false);
    this._onContinue?.();
    this._onContinue = undefined;
  }

  close() {
    this._isOpen.set(false);
    this._onContinue = undefined;
  }
}
